/**
 * Menús desplegables del modal de Baileys (doc 0439 S6): se abren BAJO el campo, con altura
 * máxima y filas densas. Sin esto, una lista de 16 departamentos tapaba la pantalla entera.
 */
export const COMPACT_MENU = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  getContentAnchorEl: null,
  PaperProps: { style: { maxHeight: 280 } },
  MenuListProps: { dense: true },
};
